import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import Item from './ui/Item';

import { Route } from '../../../Account/types';

import { isActionRoute } from '../../../Account/utils';

import { useTheme } from '../../../theme';

interface Props {
	className?: string;
	route: Route;
	isSelected?: boolean;
	onClickCallback?: () => void;
}

const SidebarItem: React.FunctionComponent<Props> = ({ className, route, isSelected, onClickCallback }) => {
	const { SidebarItem: css } = useTheme('SidebarItem');

	if (isActionRoute(route)) {
		return (
			<div
				className={cn(css.sidebarItem__wrapper, className)}
				onClick={() => {
					route.action();
					onClickCallback?.();
				}}
			>
				<Item route={route} isSelected={isSelected} />
			</div>
		);
	}

	if (route.isRedirect) {
		return (
			<a
				className={cn(css.sidebarItem__wrapper, className)}
				href={route.pathname}
				target="_blank"
				onClick={onClickCallback}
			>
				<Item route={route} isSelected={isSelected} />
			</a>
		);
	}

	return (
		<Link className={cn(css.sidebarItem__wrapper, className)} to={route.pathname} onClick={onClickCallback}>
			<Item route={route} isSelected={isSelected} />
		</Link>
	);
};

export default SidebarItem;
